<template>
  <v-expansion-panel
    v-bind="$attrs"
    :readonly="isUnactionable"
    :class="expansionPanelClass"
    v-on="$listeners"
  >
    <v-expansion-panel-header
      v-bind="$attrs"
      data-cy="expand"
      class="sn-body-2"
      :class="hideChevronDeprecatedBorrowerTeamOnly ? 'cursor-default' : ''"
      @click="handleClick()"
    >
      <template
        v-slot:actions
      >
        <slot name="activator">
          <sn-tooltip
            v-if="isUnactionable"
            direction="top"
          >
            <template v-slot:activator>
              <v-icon
                class="mr-5 ml-1"
                data-cy="lock-icon"
                color="black"
              >
                sn-icon-lock
              </v-icon>
            </template>
            <span>{{ unactionableText }}</span>
          </sn-tooltip>
          <v-icon
            v-else-if="!hideChevronDeprecatedBorrowerTeamOnly"
            class="mr-5 ml-1"
            :class="externalLoadIcon ? 'keep-icon-upright' : ''"
            color="black"
            data-cy="task-chevron"
          >
            {{ expandable ? (externalLoadIcon ? '$snChevronRight' : '$snChevronDown') : '$snChevronRight' }}
          </v-icon>
          <v-icon
            v-else
            class="mr-5 ml-1"
            color="black"
          />
        </slot>
      </template>
      <slot name="header" />
    </v-expansion-panel-header>
    <v-expansion-panel-content
      v-bind="$attrs"
      data-cy="expansion-content"
      v-on="$listeners"
    >
      <slot name="expansion" />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import snTooltip from '../snTooltip/snTooltip'

export default {
  name: 'SnExpansionPanel',
  components: {
    snTooltip
  },
  props: {
    expandable: {
      type: Boolean,
      required: false,
      default: true
    },
    hideChevronDeprecatedBorrowerTeamOnly: {
      // This should only be used by the borrower team as it's being phased out
      type: Boolean,
      required: false,
      default: false
    },
    externalLoadIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    isUnactionable: {
      type: Boolean,
      required: false,
      default: false
    },
    unactionableText: {
      type: String,
      required: false,
      default: 'Action is not allowed'
    },
    panelShadow: {
      type: Boolean,
      required: false,
      default: false
    },
    flatBorder: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    expansionPanelClass () {
      return {
        'sn-shadow-1': this.panelShadow,
        'flat-border': this.flatBorder
      }
    }
  },
  methods: {
    handleClick () {
      if (!this.expandable) {
        this.$emit('click')
      } else {
        this.$emit('expanded')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import './app/javascript/assets/css/snui/_globalVariables.scss';
@import '~/assets/css/snui/index.scss';

.flat-border {
  border-color: $sn-gray-03;
  border-width: 1px;
  border-radius: 16px !important;
  border-style: solid;
  margin-bottom: 24px;
}

.sn-shadow {
  &-1 {
    @extend .sn-shadow-depth-1;
  }
}
.vuetifycss .sn-expansion-panel,
.sn-expansion-panel{
  margin: auto;
  width: var(--content-width);
  max-width: var(--content-width);
  border-radius: 4px;
  .v-expansion-panel {
    background-color: inherit;
    border-radius: 4px;
    // hide expansion panel box shadow
    &:before{
      display:none;
    }
    .v-expansion-panel-header {
      // prevent panel header from expanding when active
      padding: 0;
      min-height: var(--header-min-height);
      justify-content: center;
        .icon-background {
          border-radius: 300px;
          height: 40px;
          width: 40px;
          padding: 7px;
        }
    }
    .v-expansion-panel-content {
      box-shadow: $sn-shadow-depth-0;
      ::v-deep .v-expansion-panel-content__wrap {
        padding: 0;
      }
    }
  }
}

.cursor-default {
  cursor: default;
}

.keep-icon-upright {
  transform: unset!important;
}
</style>
